import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Pagination, Skeleton, Typography } from "@mui/material";
import UsersList from "./UsersList";
import {
  changePageNumberUsers,
  getUsersList,
} from "../../../../redux/features/usersManagement/usersManagementSlice";
import RowContainer from "../../../common/RowContainer";
import ColumnContainer from "../../../common/ColumnContainer";
import { useGetUsersByAdminIdQuery } from "../../../../redux/features/usersManagement/usersManagementApi";
import { TitleContainer, Wrapper } from "../../style";
import useDebounce from "../../../../utils/hooks/useDebounce";
import { useAuth } from "../../../../utils/hooks/useAuth";
import { SkeletonLoading } from "../../../common/SkeletonLoading";
import { ErrorLoading } from "../../../common/ErrorLoading";

export default function UsersPage() {
  // INIT
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();

  // STATE
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  // FUNCTIONS
  const debouncedSearch = useDebounce(searchValue, 1000);
  const debouncedFilter = useDebounce(statusFilter, 100);

  const handleSearchStateChange = (value) => {
    setSearchValue(value);
  };
  const handleFilterStateChange = (value) => {
    setStatusFilter(value);
  };
  const handlePageChange = (event, value) => {
    if (value > data?.pagination?.active_page) {
      dispatch(changePageNumberUsers(data?.pagination?.active_page + 1));
    }
    if (value < data?.pagination?.active_page) {
      dispatch(changePageNumberUsers(data?.pagination?.active_page - 1));
    }
  };

  // REDUX
  const pageNumber = useSelector(
    (state) => state?.usersManagement?.usersList?.pagination?.active_page
  );
  const { auth } = useAuth();

  const {
    data,
    isLoading,
    isError,
    refetch: refetchSlaves,
  } = useGetUsersByAdminIdQuery({
    admin_id: auth?.userData?.admin_id,
    page: pageNumber || 1,
    search: debouncedSearch,
    statusFilter: debouncedFilter,
  });

  // EFFECTS
  useEffect(() => {
    if (data && pageNumber && !isLoading && !isError) {
      dispatch(getUsersList(data));
    }
  }, [data, pageNumber, isLoading, isError, dispatch]);

  useEffect(() => {
    refetchSlaves();
  }, [location.pathname, dispatch, refetchSlaves]);

  return (
    <Wrapper>
      {id ? (
        <Outlet />
      ) : (
        <ColumnContainer style={{ height: "100vh" }}>
          <ColumnContainer>
            <TitleContainer>
              <Typography variant="h3" component="h3">
                <FormattedMessage id="users.title"></FormattedMessage>
              </Typography>
            </TitleContainer>
            {isLoading ? (
              <SkeletonLoading />
            ) : isError ? (
              <ErrorLoading />
            ) : (
              <UsersList
                users={data?.paginated_results || []}
                countersData={data?.counters}
                onSearchStateChange={handleSearchStateChange}
                onFilterStateChange={handleFilterStateChange}
              />
            )}
          </ColumnContainer>
          <RowContainer center>
            {data?.pagination ? (
              <Pagination
                count={data?.pagination?.total_pages}
                page={data?.pagination?.active_page}
                onChange={handlePageChange}
              />
            ) : null}
          </RowContainer>
        </ColumnContainer>
      )}
    </Wrapper>
  );
}
